<template>
  <div v-if="page" class="min-h-screen bg-soft-white">
    <article class="container mx-auto px-6 py-12 max-w-3xl">
      <RouterLink to="/insights" class="text-sm text-light-purple font-medium">← Insights</RouterLink>
      <p class="text-xs text-dark-gray/50 mt-4 mb-2">B2B guide · Updated {{ page.date }}</p>
      <h1 class="text-4xl font-poppins font-bold text-dark-gray mb-8 leading-tight">{{ page.h1 }}</h1>
      <section v-for="sec in page.sections" :key="sec.heading" class="mb-8">
        <h2 class="text-2xl font-semibold text-dark-gray mb-3">{{ sec.heading }}</h2>
        <p v-for="(para, i) in sec.paragraphs" :key="i" class="text-dark-gray/80 leading-relaxed mb-3 text-lg">
          {{ para }}
        </p>
      </section>
      <div class="card-neumorphic !p-6 mt-10">
        <h2 class="font-semibold text-dark-gray mb-2">Talk to Homvisit</h2>
        <p class="text-sm text-dark-gray/70 mb-3">
          Corporate camps, lab partnership, or phlebotomy outsourcing in Kerala.
        </p>
        <RouterLink to="/services/phlebotomy-services-kerala" class="text-light-purple font-semibold">
          Explore phlebotomy services →
        </RouterLink>
      </div>
      <div class="mt-6 flex flex-wrap gap-2">
        <RouterLink
          v-for="href in page.related"
          :key="href"
          :to="href"
          class="text-sm text-light-purple underline"
        >{{ href }}</RouterLink>
      </div>
    </article>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getB2bArticle } from '../config/b2bArticles'
import {
  breadcrumbSchema,
  graphSchema,
  organizationSchema,
  useSeo,
} from '../composables/useSeo'
import { SITE_URL } from '../config/contact'

export default {
  name: 'InsightArticlePage',
  setup() {
    const route = useRoute()
    const page = computed(() => getB2bArticle(route.params.slug))
    useSeo(
      computed(() => {
        const p = page.value
        if (!p) return { title: 'Not found', robots: 'noindex', path: '/insights' }
        const path = `/insights/${p.slug}`
        return {
          title: p.title,
          description: p.description,
          path,
          keywords: [p.h1, 'Homvisit Kerala', 'phlebotomy outsourcing'],
          schema: graphSchema([
            organizationSchema(),
            breadcrumbSchema([
              { name: 'Home', path: '/' },
              { name: 'Insights', path: '/insights' },
              { name: p.h1, path },
            ]),
            {
              '@type': 'Article',
              headline: p.h1,
              dateModified: p.date,
              author: { '@type': 'Organization', name: 'Homvisit' },
              publisher: { '@type': 'Organization', name: 'Homvisit', url: SITE_URL },
              description: p.description,
              mainEntityOfPage: `${SITE_URL}${path}`,
            },
          ]),
        }
      })
    )
    return { page }
  },
}
</script>
